import {CreateItem, CreateItemCallbacks} from "../types";

export class CreateItemDictionary implements CreateItem {
    private items: { [key: string]: CreateItemCallbacks } = {};

    public containsKey(key: string): boolean {
        return this.items.hasOwnProperty(key);
    }

    public add(key: string, value: CreateItemCallbacks): void {
        this.items[key] = value;
    }

    public remove(key: string): void {
        delete this.items[key];
    }

    public get(key: string): CreateItemCallbacks {
        return this.items[key];
    }
}

export default new CreateItemDictionary();
